import type { PropsWithChildren } from 'react'
import { App as AntdApp, ConfigProvider, theme } from 'antd'

export function ThemeProvider({ children }: PropsWithChildren) {
  return <ConfigProvider theme={{
    algorithm: theme.darkAlgorithm,
    token: {
      colorPrimary: '#7c5cfc',
      colorInfo: '#22d3ee',
      colorSuccess: '#37d67a',
      colorWarning: '#f6c85f',
      colorError: '#ff5c7a',
      colorBgLayout: '#070a12',
      colorBgContainer: '#0e1420',
      colorBgElevated: '#151d2c',
      colorText: '#f2f5fa',
      colorTextSecondary: 'rgba(226,232,240,.78)',
      colorTextTertiary: 'rgba(226,232,240,.62)',
      colorTextQuaternary: 'rgba(226,232,240,.5)',
      colorBorder: 'rgba(125,150,190,.2)',
      colorBorderSecondary: 'rgba(255,255,255,.07)',
      fontSize: 14,
      fontSizeSM: 12,
      fontSizeLG: 16,
      lineHeight: 1.6,
      borderRadius: 8,
      borderRadiusLG: 12,
      controlHeight: 36,
      controlHeightLG: 44,
      fontFamily: 'Inter, "PingFang SC", "Microsoft YaHei", sans-serif',
    },
    components: {
      Button: { primaryShadow: '0 8px 24px rgba(124,92,252,.28)' },
      Input: { activeBg: '#0b111b', hoverBg: '#0b111b', activeBorderColor: '#22d3ee', hoverBorderColor: '#67e8f9', activeShadow: '0 0 0 2px rgba(34,211,238,.14)' },
      Select: { selectorBg: '#121a28', optionSelectedBg: 'rgba(124,92,252,.18)' },
      Modal: { contentBg: '#101724', headerBg: '#101724' },
      Slider: { trackBg: '#7c5cfc', trackHoverBg: '#9278ff', handleColor: '#a894ff' },
      Upload: { pictureCardSize: 76 },
    },
  }}><AntdApp>{children}</AntdApp></ConfigProvider>
}
